import React from 'react';
import { Select } from '@avila-tek/ui/src';

interface ReceivableFiltersProps {
  setPaidFilter: React.Dispatch<React.SetStateAction<boolean>>;
  setStatusFilter: React.Dispatch<React.SetStateAction<string>>;
  paidFilter: boolean;
  statusFilter: string;
}

function ReceivableFilters({
  setPaidFilter,
  setStatusFilter,
  paidFilter,
  statusFilter,
}: ReceivableFiltersProps) {
  const activeClass = 'bg-purple-200 text-white';
  const inactiveClass = 'bg-white text-purple-300 ';

  return (
    <div className="flex lg:flex-row flex-col items-center ">
      <div className="flex lg:flex-row flex-col ">
        <label
          htmlFor="Toggle3"
          className="flex flex-col space-y-2 lg:flex-row lg:space-y-0 lg:inline-flex items-center p-2 rounded-md cursor-pointer dark:text-gray-800"
        >
          <button
            type="button"
            onClick={() => setPaidFilter(true)}
            className={`px-4 py-2 rounded lg:rounded-none lg:rounded-l-md font-semibold border border-purple-200  ${
              paidFilter ? activeClass : inactiveClass
            }`}
          >
            Pagadas
          </button>
          <button
            type="button"
            onClick={() => setPaidFilter(false)}
            className={`px-4 py-2 font-semibold border border-purple-200 ${
              paidFilter !== false ? inactiveClass : activeClass
            }`}
          >
            Por pagar
          </button>
          <button
            type="button"
            onClick={() => setPaidFilter(null)}
            className={`px-4 py-2 rounded lg:rounded-none lg:rounded-r-md font-semibold border border-purple-200 ${
              paidFilter !== null ? inactiveClass : activeClass
            }`}
          >
            Todas
          </button>
        </label>
      </div>
      <div className="w-48">
        <Select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option value="">Todas</option>
          <option value="approved">Aprobadas</option>
          <option value="declined">Rechazadas</option>
          <option value="pending">Pendientes</option>
          <option value="cancelled">Canceladas</option>
        </Select>
      </div>
    </div>
  );
}

export default ReceivableFilters;
